export interface PurchaseOrders {
  primary: string;
  additional: string[];
}

export interface PurchaseOrderSnapshot extends PurchaseOrders {
  lading_uuid: string;
  revision: string;
  can_edit: boolean;
  blocked_reason: string | null;
  shared_ladings: number;
  integration: {
    po_sync_enabled: boolean;
    pending_operations: number;
    pending_edits: number;
    reviews: { field_name: string; reason: string }[];
    rerating: { field_name: string; recorded_at: string }[];
  };
}

export function normalizedPurchaseOrders(value: PurchaseOrders): PurchaseOrders {
  return { primary: value.primary.trim(), additional: value.additional.map(po => po.trim()).sort() };
}

export function purchaseOrderError(value: PurchaseOrders): string {
  const normalized = normalizedPurchaseOrders(value);
  const all = normalized.primary ? [normalized.primary, ...normalized.additional] : normalized.additional;
  if (all.length > 20) return 'Use no more than 20 POs in total.';
  if (all.some(po => !po)) return 'Enter a PO or remove its empty row.';
  if (new Set(all).size !== all.length) return 'Each PO should appear once. Use Make primary to move a PO.';
  // FoxPro stores these references in a 35-byte Windows-1252 field.
  const special = '€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ';
  if (all.some(po => Array.from(po).length > 35 || Array.from(po).some(c => {
    const code = c.codePointAt(0)!;
    return !((code >= 32 && code <= 126) || (code >= 160 && code <= 255) || special.includes(c));
  }))) return 'Each PO must fit 35 characters. Remove unsupported characters or line breaks.';
  return '';
}

export function promotePurchaseOrder(value: PurchaseOrders, index: number): PurchaseOrders {
  const additional = [...value.additional];
  const primary = additional.splice(index, 1)[0];
  if (value.primary) additional.push(value.primary);
  return { primary, additional };
}

export function samePurchaseOrders(a: PurchaseOrders, b: PurchaseOrders): boolean {
  return JSON.stringify(normalizedPurchaseOrders(a)) === JSON.stringify(normalizedPurchaseOrders(b));
}
